import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import search_icon from '../assets/images/search_icon.svg';
import config from '../config/config'; // Adjust import path as necessary

const SidebarSearch = () => {
  const [searchInput, setSearchInput] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [mentionList, setMentionList] = useState([]);
  const [showResults, setShowResults] = useState(false); // New state for dropdown visibility
  const searchRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowResults(false); // Hide results dropdown when clicking outside
        setShowMessage(searchInput === ''); // Show empty message if input is empty
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [searchInput]); // Add searchInput as a dependency to update showMessage correctly

  const handleInputChange = (e) => {
    const query = e.target.value;
    setSearchInput(query);
    setShowResults(true); // Show results when typing
    if (query === '') {
      setShowMessage(true);
      setMentionList([]); // Clear mention list when input is empty
    } else {
      setShowMessage(false);
      fetchMentions(query); // Fetch user list based on input
    }
  };

  const handleInputFocus = () => {
    setShowResults(true); // Show results when input is focused
    if (searchInput === '') {
      setShowMessage(true);
    } else {
      fetchMentions(searchInput); // Re-fetch results if input is not empty
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    console.log("Searching for:", searchInput);
    setShowResults(false); // Optionally hide results on submit
    setShowMessage(false);
  };

  const fetchMentions = async (query) => {
    if (!query) {
      setMentionList([]);
      return;
    }

    try {
      const response = await axios.get(`${config.baseURL}/get-mentions-creators`, {
        params: { query },
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });

      const lowerCaseQuery = query.toLowerCase();
      const filteredList = response.data.data
        .map(item => ({
          id: item.user.id,
          user_name: item.user.user_name,
          name: item.user.name,
          profile: item.user.profile,
        }))
        .filter(user =>
          user.user_name.toLowerCase().includes(lowerCaseQuery) ||
          user.name.toLowerCase().includes(lowerCaseQuery)
        );

      setMentionList(filteredList);
    } catch (error) {
      console.error('Error fetching mentions:', error);
      setMentionList([]);
    }
  };

  return (
    <div className="search_sidebar" ref={searchRef}>
      <form onSubmit={handleSearchSubmit}>
        <input
          className="form-control"
          type="text"
          maxLength={100}
          placeholder="Search users"
          value={searchInput}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
        />
        <button type="submit" className="search_btn">
          <img src={search_icon} alt="search icon" />
        </button>
        {showMessage && searchInput === '' && (
          <div className="empty-message">
            Try searching for users or posts
          </div>
        )}
        {showResults && !showMessage && searchInput !== '' && (
          <div className="search-results">
            {mentionList.length > 0 ? (
              <ul className="mention-list-search">
                {mentionList.map((user, index) => (
                  <li key={index}>
                    <a href={`${user.user_name}`} onClick={() => setShowResults(false)}>
                      <div className="imagebox">
                        {user.profile ? (
                          <img src={user.profile} alt={user.user_name} />
                        ) : (
                          <div className="name_box_mentions">
                            {user.name.split(' ').map(n => n[0]).join('')}
                          </div>
                        )}
                      </div>
                      {user.name}
                    </a>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="no-results">
                No users found
              </div>
            )}
          </div>
        )}
      </form>
    </div>
  );
};

export default SidebarSearch;